import { render, staticRenderFns } from "./DashboardCardPagination.vue?vue&type=template&id=33b0e80a&scoped=true"
import script from "./DashboardCardPagination.vue?vue&type=script&lang=js"
export * from "./DashboardCardPagination.vue?vue&type=script&lang=js"
import style0 from "./DashboardCardPagination.vue?vue&type=style&index=0&id=33b0e80a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b0e80a",
  null
  
)

export default component.exports